import {ElasticParser, ElasticSearchProperties} from '../factory.parsers';
import {buildQueryTermEqual} from '../../query/elastic.queries';

export class SkyObjectTypesParser implements ElasticParser {
  parseValue(skyObjectTypesDataParsed: any, elasticSearchProperties: ElasticSearchProperties): any {
    const {objectTypesSimbad, objectTypesNed} = elasticSearchProperties;
    const {isBestMatchSelected, skyObjectSimbadTypes, skyObjectNedTypes} = skyObjectTypesDataParsed;

    const skyObjectSimbadTypesQuery = skyObjectSimbadTypes?.split(',')
      .map(skyObjectType => skyObjectType.trim())
      .filter(skyObjectType => !!skyObjectType)
      .map(skyObjectType => isBestMatchSelected
        ? buildQueryTermEqual(objectTypesSimbad.isBestMatch, skyObjectType)
        : buildQueryTermEqual(objectTypesSimbad.longtype, skyObjectType)
      );

    const skyObjectNedTypesQuery = skyObjectNedTypes?.split(',')
      .map(skyObjectType => skyObjectType.trim())
      .filter(skyObjectType => !!skyObjectType)
      .map(skyObjectType => isBestMatchSelected
        ? buildQueryTermEqual(objectTypesNed.isBestMatch, skyObjectType)
        : buildQueryTermEqual(objectTypesNed.longtype, skyObjectType)
      );

    if (skyObjectSimbadTypesQuery?.length > 0 || skyObjectNedTypesQuery?.length > 0) {
      return {bool: {should: [...(skyObjectSimbadTypesQuery || []), ...(skyObjectNedTypesQuery || [])]}};
    } else {
      return undefined;
    }
  }
}
